export default {
  // Navigation
  "nav.employees": "Employees",
  "nav.departments": "Departments",

  // Employees list
  "employees.title": "Employees",
  "employees.name": "Name",
  "employees.work_email": "Work Email",
  "employees.work_phone": "Work Phone",
  "employees.work_mobile": "Work Mobile",
  "employees.department": "Department",
  "employees.job_title": "Job Title",
  "employees.manager": "Manager",
  "employees.state": "State",
  "employees.select_tenant": "Please select a tenant first.",
  "employees.delete_confirm": "Are you sure you want to delete this employee?",
  "employees.created": "Employee created successfully",
  "employees.updated": "Employee updated successfully",

  // Employee form sections
  "employees.section.work": "Work Information",
  "employees.section.personal": "Personal Information",
  "employees.section.emergency": "Emergency Contact",
  "employees.section.address": "Private Address",

  // Employee form validation
  "employees.error.name_required": "Employee name is required",

  // User account
  "employees.user": "User Account",

  // Employee form fields
  "employees.private_email": "Private Email",
  "employees.private_phone": "Private Phone",
  "employees.birthday": "Birthday",
  "employees.gender": "Gender",
  "employees.nationality": "Nationality",
  "employees.identification_no": "Identification Number",
  "employees.bank_account": "Bank Account",
  "employees.emergency_contact_name": "Emergency Contact Name",
  "employees.emergency_contact_phone": "Emergency Contact Phone",
  "employees.private_street": "Street",
  "employees.private_city": "City",
  "employees.private_zip": "Postal Code",
  "employees.private_country": "Country",

  // Departments
  "departments.title": "Departments",
  "departments.name": "Name",
  "departments.parent": "Parent Department",
  "departments.manager": "Manager",
  "departments.state": "State",
  "departments.select_tenant": "Please select a tenant first.",
  "departments.delete_confirm": "Are you sure you want to delete this department?",
  "departments.error.name_required": "Department name is required",
  "departments.created": "Department created successfully",
  "departments.updated": "Department updated successfully",
};
